'use client'

import ImageWithFallback from '@/components/common/image-with-fallback'
import MenuDotsIcon from '@/components/icons/menu-dots'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { TableCell } from '@/components/ui/table'
import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import { getUserProfilePictureUrl } from '@/helpers/user'
import dayjs from '@/lib/dayjs'
import { getDriverDisplayIdentifierDisplay } from '@/lib/driver-display-identifiers'
import Link from 'next/link'

export default function OverviewDriverTableRowMobile({
  attendee,
  setValue,
  showTeams,
  showCarClasses,
  showSplits,
  isManagerSide,
}) {
  return (
    <TableCell className="flex w-full flex-col" colSpan={6}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-nowrap py-2 pr-4">
          <div className="relative flex aspect-square h-10 w-10 min-w-10 overflow-hidden rounded-full">
            <ImageWithFallback
              src={getUserProfilePictureUrl(attendee.user, {
                profile: 'driver',
              })}
              alt="User Image"
              fill
            />
          </div>
          {getDriverDisplayIdentifierDisplay(attendee, 'nickname')}
        </div>

        {isManagerSide && (
          <div className="flex items-center justify-end gap-2">
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger className="h-full" asChild>
                <Button variant="icon" className="px-2">
                  <MenuDotsIcon className="h-full w-6 fill-shades-0" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-40">
                <DropdownMenuItem
                  className="cursor-pointer hover:bg-slate-200"
                  onClick={() => {
                    setValue('selectedAttendee', attendee)
                    setValue('selectedReason', 'ban')
                    document.body.style.pointerEvents = 'unset !important'
                  }}
                >
                  Ban member
                </DropdownMenuItem>

                <DropdownMenuItem
                  className="cursor-pointer hover:bg-slate-200"
                  onClick={() => {
                    setValue('selectedAttendee', attendee)
                    setValue('selectedReason', 'kick')
                    document.body.style.pointerEvents = 'unset !important'
                  }}
                >
                  Kick member
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>

      <Accordion type="single" collapsible className="w-full">
        <AccordionItem
          className="border-b-0! border-neutral-blue-700! border-t"
          value="driver-details"
        >
          <AccordionTrigger
            className="-mb-2 justify-center gap-1 [&[data-state=closed]>span.closed]:hidden [&[data-state=open]>span.open]:hidden"
            iconClassName="stroke-neutral-blue-200!"
          >
            <span className="open order-2 text-neutral-blue-200">
              Show more
            </span>
            <span className="closed order-2 text-neutral-blue-200">
              Show less
            </span>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col gap-4">
              {isManagerSide && (
                <div className="flex items-center justify-between gap-1">
                  <div className="font-medium text-neutral-blue-200">
                    Applied as{' '}
                    <span className="capitalize">
                      {attendee.role || 'driver'}
                    </span>
                  </div>
                  {dayjs(attendee.createTs).fromNow()}
                </div>
              )}

              {showTeams && (
                <div className="flex items-center justify-between gap-1">
                  <div className="font-medium text-neutral-blue-200">Team</div>
                  {attendee.team?.name ?? '-'}
                </div>
              )}

              {showCarClasses && (
                <div className="flex items-center justify-between gap-1">
                  <div className="font-medium text-neutral-blue-200">
                    Car Class
                  </div>
                  {attendee.carClass?.name ?? '-'}
                </div>
              )}

              {showSplits && (
                <div className="flex items-center justify-between gap-1">
                  <div className="font-medium text-neutral-blue-200">Split</div>
                  {attendee.split?.name ?? '-'}
                </div>
              )}

              <Button size="sm" asChild>
                <Link
                  href={urlSafeProfilePath({
                    ...attendee.user,
                    id: attendee.userId,
                    profileType: 'driver',
                  })}
                  target="_blank"
                >
                  View Profile
                </Link>
              </Button>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </TableCell>
  )
}
